export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/492fb0a6c97aabdb068851b0471b977c.jpg)'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-32">
        <div className="max-w-4xl mb-32 md:mb-0">
          <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold text-white leading-tight mb-6" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            HOME SECURITY<br />AND CONNECTIVITY<br />SOLUTIONS
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-12 max-w-2xl leading-relaxed">
            Advanced home security systems with 24/7 professional monitoring and smart home integration
          </p>
          <div className="flex flex-wrap gap-4">
            <button onClick={() => scrollToSection('contact')} className="whitespace-nowrap px-8 py-4 bg-teal-600 text-white rounded-full text-base font-semibold hover:bg-teal-700 transition-all cursor-pointer shadow-lg">
              Get Free Quote
            </button>
          </div>
        </div>

        <div className="absolute bottom-12 left-6 right-6 flex flex-wrap gap-6 justify-center md:justify-start">
          <div className="bg-white/10 backdrop-blur-md px-6 py-4 rounded-2xl border border-white/20">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-teal-600 rounded-full">
                <i className="ri-shield-check-line text-xl text-white"></i>
              </div>
              <div>
                <p className="text-white font-semibold text-sm">24/7 Professional Monitoring</p>
                <p className="text-white/70 text-xs">Always protected</p>
              </div>
            </div>
          </div>
          <div className="bg-white/10 backdrop-blur-md px-6 py-4 rounded-2xl border border-white/20">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-teal-600 rounded-full">
                <i className="ri-home-smile-line text-xl text-white"></i>
              </div>
              <div>
                <p className="text-white font-semibold text-sm">Smart Home Integration</p>
                <p className="text-white/70 text-xs">Control everything</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
